let mutations = {
  set_statement (state, data) {
    state.statement = data
    state.filteredStatement = data
  },
  set_recentTransactions (state, data) {
    if (data.append) {
      for (let i = 0; i < data.response.length; i++) {
        if (state.recentTransactions.response[state.recentTransactions.response.length - 1].description ==
          data.response[i].description) {
          for (let j = 0; j < data.response[i].transactions.length; j++) {
            if (state.recentTransactions.response[state.recentTransactions.response.length - 1].transactions[state.recentTransactions.response[state.recentTransactions.response.length - 1].transactions.length - 1].id
              != data.response[i].transactions[j].id) {
              state.recentTransactions.response[state.recentTransactions.response.length - 1].transactions.push(data.response[i].transactions[j]);
            }
          }
        }
        else {
          state.recentTransactions.response.push(data.response[i]);
        }
      }
    }
    else {
      state.recentTransactions = data
    }
  },
  set_statement_categories (state, data) {
    state.statementCategories = data
    state.statementCategories.unshift('All')
  },
  filter_statement (state, data) {
    if (data === 'All') {
      state.filteredStatement = state.statement
    } else {
      state.filteredStatement = state.statement.filter(statement => statement.category.replace(/\s/g, '') === data)
    }
  },
  set_transactionsCount (state, data) {
    state.totalTransactionCount = data
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/statement/mutations.js